import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getSessionId, setAnonSessionId } from '../utils/sessionManager';

const fields = "&fields=ip_address,city,region,region_iso_code,postal_code,country,country_code,continent";

const getConnectionDetails = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_ABSTRACT_URL + fields);
        const data = await response.json();
        if (response.status === 200) {
            return { ...data };
        }
        return null;
    } catch (err) {
        console.error("Failed to fetch connection details:", err);
        return null;
    }
};

const usePageTracking = (pageName) => {
    const { user } = useSelector((state) => state.authReducer.authData) || {};
    const sessionId = localStorage.getItem('sessionId');
    const hasLogged = useRef(false);
    const startTime = useRef(Date.now());
    const isRealMount = useRef(false);

    useEffect(() => {
        startTime.current = Date.now();
        if (hasLogged.current) {
            isRealMount.current = true;
        } else {
            hasLogged.current = true;
            isRealMount.current = false;
        }
        if (isRealMount.current) {
            const logPageView = async () => {
                const connectionDetails = await getConnectionDetails();

                const logDetails = {
                    activity: "page_view",
                    category: "navigation",
                    page: pageName,
                    userId: user?._id || null,
                    sessionId: getSessionId(),
                    referrer: document.referrer || null,
                    data: {
                        userId: user?._id || null,
                        username: user?.username || null,
                        ...(connectionDetails && { ...connectionDetails })
                    },
                    status: connectionDetails ? 'success' : 'failure'
                };

                fetch(`${process.env.REACT_APP_API_BASE_URL}/logs`, {
                    method: 'PUT',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ data: JSON.stringify(logDetails) })
                })
                .then(res => res.json())
                .then(data => {
                    if (data.sessionId && !localStorage.getItem('sessionId')) {
                        setAnonSessionId(data.sessionId);
                    }
                });
            };

            logPageView();           
        }

        return async () => {
            if (!isRealMount.current) return;
            const duration = Math.floor((Date.now() - startTime.current) / 1000);
            const leaveDetails = {
                activity: "page_leave",
                category: "navigation",
                page: pageName,
                userId: user?._id || null,
                data: {
                    userId: user?._id || null,
                    username: user?.username || null,
                    duration: duration
                },
                sessionId,
                duration
            };

            const blob = new Blob(
                [JSON.stringify({ data: JSON.stringify(leaveDetails) })], 
                { type: 'application/json' }
            );
            navigator.sendBeacon(
                `${process.env.REACT_APP_API_BASE_URL}/logs/beacon`,
                blob
            );
        };
    }, []);
};

export default usePageTracking;